module.exports = __webpack_public_path__ + "static/media/mobile-access-warning.35955c4f.svg";